import React from 'react';
import { Icon } from '@iconify/react';

const Footer = () => {
  return (
    <footer id="footer" className="footer dark-background">
      <div className="container">
        <h3 className="sitename">SIMANAP</h3>
        <p>
          Ikuti kami di media sosial untuk tetap update dengan info kesehatan
          dan layanan terbaik dari Rumah Sakit Umum Daerah H. Abdul Manap Kota
          Jambi.
        </p>
        <div className="social-links d-flex justify-content-center">
          <a
            href="https://www.facebook.com/rsudhamkotajambi"
            aria-label="Kunjungi akun facebook kami"
          >
            <i className="bi bi-facebook"></i>
          </a>
          <a
            href="https://www.instagram.com/rsudkotajambi/"
            aria-label="Kunjungi akun instagram kami"
          >
            <i className="bi bi-instagram"></i>
          </a>
          <a
            href="https://www.youtube.com/@rsudjambikota"
            aria-label="Kunjungi channel youtube kami"
          >
            <i className="bi bi-youtube"></i>
          </a>
        </div>
        <div className="copyright">
          <span>Copyright© </span>
          {new Date().getFullYear()}
          <strong className="px-1 sitename">
            SIMRS | RSUD H ABDUL MANAP KOTA JAMBI.
          </strong>{' '}
          <span>All Rights Reserved</span>
        </div>
        <div className="credits"></div>
      </div>
      <a
        href="#"
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
      >
        <Icon icon="iconamoon:arrow-up-6-circle" className="custom-icon" />
      </a>
    </footer>
  );
};

export default Footer;
